import { PropsWithChildren } from "react";
import { FixaAccordionItem } from "@coworker/apprestructured/src/shared/wrappers/FixaAccordion/FixaAccordion";
import FilterAccordionCss from "./FilterAccordion.module.css";
import { Filter } from "../../types/filter";

interface FilterAccordionProps {
  filter: Filter;
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  title?: string;
}

export const FilterAccordionItem = ({
  filter,
  open,
  onOpenChange,
  title = filter.title,
  children,
}: PropsWithChildren<FilterAccordionProps>) => {
  const { id } = filter;
  return (
    <FixaAccordionItem
      id={`filter-accordion-${id}`}
      data-testid={`filter-accordion-${id}`}
      title={title}
      className={FilterAccordionCss["accordion-item-title"] ?? ""}
      open={!!open}
      onTransitionEnd={(_event, isOpen) => {
        onOpenChange(isOpen);
      }}
    >
      {children}
    </FixaAccordionItem>
  );
};
